﻿{
  "version": 1,
  "gameId": "uno",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "uno.rules.navigationLabel",
    "kickerKey": "uno.rules.kicker",
    "titleKey": "uno.rules.title",
    "summaryKey": "uno.rules.summary",
    "sections": [
      { "id": "setup", "key": "uno.rules.setup" },
      { "id": "match", "key": "uno.rules.match" },
      { "id": "draw", "key": "uno.rules.draw" },
      { "id": "actions", "key": "uno.rules.actions" },
      { "id": "wild", "key": "uno.rules.wild" },
      { "id": "win", "key": "uno.rules.win" },
      { "id": "modes", "key": "uno.rules.modes" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {}
}
